module.exports = __webpack_public_path__ + "static/media/sensor.d1fac651.svg";